export default __webpack_public_path__ + "static/media/1102.77ec12a3.png";